const oss = {

    checkAllSuccess(listObj) {
        return Object.keys(listObj).every(item => listObj[item].hasSuccess)
    },
    imgSuccess(file,listObj,dataObj){
        const host = 'https://zkvip-oss.oss-cn-hongkong.aliyuncs.com';
        const uid = file.uid;
        const objKeyArr = Object.keys(listObj)
        for (let i = 0, len = objKeyArr.length; i < len; i++) {

            console.log(listObj[objKeyArr[i]].uid);
            console.log(uid);
            if (listObj[objKeyArr[i]].uid === uid) {
            listObj[objKeyArr[i]].url = host + '/' + dataObj.dir + '/' + dataObj.timeStamp + file.name;
            listObj[objKeyArr[i]].hasSuccess = true;
            return
            }
        }
    },
    imgRemove(file,listObj){
        const uid = file.uid;
        const objKeyArr = Object.keys(listObj);
        for (let i = 0, len = objKeyArr.length; i < len; i++) {
          if (listObj[objKeyArr[i]].uid === uid) {
            delete listObj[objKeyArr[i]];
            return
          }
        }
    },
    //图片压缩
    imgCompress(file,listObj,resolve,reject){
        let compressScale = 0.5;
        if(file.size/1024 > 1025&&file.size/1024<3073){
            compressScale = 0.3;
        }
        else if(file.size/1024>3072&&file.size/1024<5121){
            compressScale = 0.1;
        }
        else if(file.size/1024>5121){
            compressScale = 0.01;
        }
        console.log('compressScale',compressScale)
        const fileName = file.uid;
        listObj[fileName] = {};
        let image = new Image(), resultBlob = '';
        image.src = URL.createObjectURL(file);
        image.onload = () => {
            // 调用方法获取blob格式，方法写在下边
            resultBlob = this.compressUpload(image, file,compressScale);
            resolve(resultBlob)
        }
        image.onerror = () => {
            reject()
        }
        listObj[fileName] = {hasSuccess: false, uid: file.uid, width: this.width, height: this.height};

    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload(image, file,compressScale) {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let initSize = image.src.length
        let { width } = image, { height } = image
        canvas. width = width
        canvas.height = height
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(image, 0, 0, width, height)
        // 最小压缩
        let compressData = canvas.toDataURL(file.type || 'image/jpeg', compressScale);
        // 压缩后调用方法进行base64转Blob，方法写在下边
        let blobImg = this.dataURItoBlob(compressData)
        return blobImg
    },

    /* base64转Blob对象 */
    dataURItoBlob(data) {
        let byteString;
        if(data.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(data.split(',')[1])
        }else {
            byteString = unescape(data.split(',')[1])
        }
        let mimeString = data
            .split(',')[0]
            .split(':')[1]
            .split(';')[0];
        let ia = new Uint8Array(byteString.length)
        for( let i = 0; i < byteString.length; i += 1) {
            ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ia], {type: mimeString})
    },

  }
  export default oss;
